/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Questionnaire Answer model
 */
export class QuestionnaireAnswerModel { 
    /**
     * Question unique identifier
     */
    QuestionID?: number;
    /**
     * Answer
     */
    Answer?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/model/questionnaireAnswerModel.ts